import React from 'react';

const IndustriesHero = () => {
    return (
        <section className="relative w-full h-[600px] lg:h-[630px] flex items-center bg-[#000814] overflow-hidden">
            <div className="absolute inset-0 z-0">
                <img
                    src="/assets/in/bg1.png"
                    alt="Abstract 3D Background"
                    className="w-full h-full object-cover"
                />
                <div style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }} className="absolute inset-0 "></div>
            </div>
            <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] lg:px-[80px] flex flex-col items-start justify-center h-full">

                <div className="mt-16 lg:mt-0">
                    <h1 className="text-white font-[600] text-5xl md:text-[60px] font-sora leading-[1.1] mb-[22px] drop-shadow-xl tracking-wide text-left">
                        Industries
                    </h1>
                    <p className="text-[#FFFFFF] text-[14px] md:text-[16px] leading-[24px] font-graphik font-[500] tracking-wider text-left">
                        Technology. Transformation. Trust.
                    </p>
                </div>

            </div>

        </section>
    );
};

export default IndustriesHero;